import React, { useEffect, useState, useRef } from 'react';

import ContentHeader from '../ContentHeader/ContentHeader';
import Content from '../Content/Content';
import MediaShareFooter from '../MediaShareFooter/MediaShareFooter';
import Footer from '../../../common/Footer/Footer';
import SuggestionFooter from '../BlogpostSuggestionFooter/BlogpostSuggestionFooter';

import * as classes from './blogPageLayout.module.css';

export default function BlogPostLayout({
  blog,
  suggestionBlogs,
  isPreview = false,
}) {
  const [scroll, setScroll] = useState('0');
  const contentRef = useRef(null);
  const { featuredImage = {} } = blog;

  useEffect(() => {
    let progressBarHandler = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight =
        contentRef.current.offsetHeight - document.documentElement.clientHeight;
      const scroll = `${totalScroll / windowHeight}`;

      setScroll(scroll);
    };

    window.addEventListener('scroll', progressBarHandler);

    return () => window.removeEventListener('scroll', progressBarHandler);
  });

  let footer = null;
  if (isPreview !== true) {
    footer = (
      <>
        <div>
          <MediaShareFooter slug={blog.slug} title={blog.title} />
          <SuggestionFooter
            blogId={blog.id}
            suggestionBlogs={suggestionBlogs}
          />
          <Footer />
        </div>
        <div className={classes.progressBarContainer}>
          <div
            className={classes.progressBar}
            style={{ transform: `scale(${scroll}, 1)` }}
          />
        </div>
      </>
    );
  }

  return (
    <div className={classes.site}>
      <div className={classes.site_Content}>
        <div ref={contentRef}>
          <ContentHeader
            template={blog?.templateFormat?.templateOption[0] || '0'}
            featuredImage={featuredImage}
          />
          <Content blog={blog} />
        </div>
        {footer}
      </div>
    </div>
  );
}
